import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { Cookie } from '../../utils/cookie';
import { TmUPSLocatorRequest } from '../model/request/upslocator-request';
import { TmUPSLocatorResponse } from '../model/upslocator';

import { ApiBase } from './apibase.service';


export class UpsLocator extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    post(locatorRequest: TmUPSLocatorRequest): Observable<TmUPSLocatorResponse> {
        const cookie = new Cookie();
        const locatorUrl = this.baseUrl + '/ups/locator';
        return this.getAppToken()
            .map((tokenResp) => tokenResp)
            .flatMap((accessToken) => {
                return this.http
                    .post(locatorUrl, locatorRequest, { headers: this.appTokenJsonTypeHeader })
                    .map((locatorData) => locatorData.json() as TmUPSLocatorResponse)
                    .catch(this.handleError);
            });
    }
}(UpsLocator as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/upslocator.service.ts